import { COMPONENT_STATES, COMPONENT_TYPE as TYPE, DEFAULT_MEDIA_QUERY_PLATFORMS } from 'common/constants';
import { generateElementId, generateNodeId } from 'utils/generate-id';
import View from 'client/components/common/BuildingBlocks/Lottie/Lottie';
import { OTHER_PROPS } from 'common/constants/component-props';

export const LOTTIE = () => {
	const _id = generateElementId();

	return {
		view: View,
		model: {
			_id,
			type: TYPE.LOTTIE,
			uiConfig: {
				layer: undefined,
				editorProps: {
					name: LOTTIE.displayName,
					selectable: true,
					draggable: true,
					expandable: false,
					expanded: false,
				},
				nodeProps: {
					id: generateNodeId(_id, LOTTIE.displayName),
				},
				componentProps: {
					styles: {},
					other: {
						[COMPONENT_STATES.DEFAULT]: {
							[DEFAULT_MEDIA_QUERY_PLATFORMS.DEFAULT]: {
								[OTHER_PROPS.lottie.ltSrc]:
									// eslint-disable-next-line max-len
									'https://dev-low-cost-galleryassetsbucket9eb44ac2-pkzruw7z30pc.s3.eu-west-1.amazonaws.com/2023/07/27/1690448794362-76caa0a8-1124-41b6-bd99-d5a51d7f5647.json',
							},
						},
					},
				},
			},
			children: [],
		},
	};
};

LOTTIE.displayName = 'Lottie';
